import "./Nlp.css";
import React, {useEffect, useState} from "react";
import NlpHeaders from "./NlpHeaders/NlpHeaders";
import NlpContainer from "./NlpContainer/NlpContainer";
import {jwtDecode} from "jwt-decode";

interface TokenPayload {
    exp: number;
    business_type_id: number;
}

const Nlp: React.FC = () => {
    const [isAuthorized, setIsAuthorized] = useState(false);

    useEffect(() => {
        const checkAuth = () => {
            const token = localStorage.getItem("authToken");
            if (!token) return;

            try {
                const decoded = jwtDecode<TokenPayload>(token);
                const now = Date.now() / 1000;
                const expiresAt = decoded.exp;
                const isValid = expiresAt - 300 > now; // 5 min buffer
                const hasValidType = decoded.business_type_id === 2;

                setIsAuthorized(isValid && hasValidType);
            } catch (error) {
                console.error("Invalid token:", error);
                setIsAuthorized(false);
            }
        };

        checkAuth();
    }, []);

    if (!isAuthorized) {
        return (
            <div className="unauthorized">
                ⛔ Unauthorized
                <br />
                <button
                    onClick={() => {
                        localStorage.removeItem("authToken");
                        window.location.href = "/";
                    }}
                    style={{
                        marginTop: "1rem",
                        padding: "8px 16px",
                        cursor: "pointer",
                        backgroundColor: "#007bff",
                        color: "white",
                        border: "none",
                        borderRadius: "4px"
                    }}
                >
                    Login
                </button>
            </div>
        );
    }

    return (
        <div className="nlp-main-page">
            <NlpHeaders></NlpHeaders>
            <NlpContainer></NlpContainer>
        </div>
    );
};

export default Nlp;
